import React, { forwardRef } from 'react';
import { PropTypes } from 'prop-types';

const FormRow = forwardRef(({ className, children }, ref) => (
  <div ref={ref} className={`${className} flex flex-col md:flex-row gap-4 mb-4`}>
    {children}
  </div>
));

FormRow.displayName = 'FormRow';

FormRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FormRow.defaultProps = {
  className: '',
};

export default FormRow;
